<uni-chart [options]="chartOptions"></uni-chart>
